import { FormHelperTextClassKey, FormHelperTextProps } from '@material-ui/core/FormHelperText'
import { StyleRules } from '@material-ui/core/styles/withStyles'

export const MuiFormHelperText: Partial<StyleRules<FormHelperTextClassKey, FormHelperTextProps>> = {
    root: { minHeigtht: '14px' },
    contained: { marginTop: '4px', minHeight: '14px' }
}
